import {call, fork, put, select} from "redux-saga/effects";
import deltas from "../../redux/actions/deltas";
import routes from "../../redux/routes";
import redirect from "../../redux/helpers/redirect";
import loading from "./loading";
import appStates from "../../redux/states/app";
import tryToRefreshToken from "../helpers/tryToRefreshToken";
import loggedOut from "./loggedOut";
import appLogin from "./appLogin";

const {
    startImpersonating,
    setAppState,
} = deltas.actionCreators;

export default function* impersonate() {
    const userIdToImpersonate = yield select(state => state.impersonation.userIdToImpersonate);

    if (null === userIdToImpersonate) {
        return;
    }

    yield put(startImpersonating());

    // Make sure we're still authenticated (and set the role to CAREERS_LEAD if so)
    const success = yield call(tryToRefreshToken);

    if (!success) {
        return yield fork(loggedOut);
    }

    try {
        yield call(appLogin);

        // Reload all the app data from the perspective of the CEC admin user
        yield call(loading,true);
    } catch (e) {
        return yield fork(loggedOut);
    }

    // Reload all the app data from the perspective of the impersonated user
    yield call(loading,true);

    yield put(redirect(routes.CL_PROFILE));
    yield put(setAppState(appStates.LOGGED_IN));
}
